import { Component, ViewChild  } from '@angular/core';
import { Location } from '@angular/common';
import { EmployerViewService } from './employer.view.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { AppService } from '../../app.service';
import { ActivatedRoute } from '@angular/router'; 
import { AppConfig } from '../../app.config';
import { Globals } from '../../globals';
import translateJson from "../../../translate.json";
import customerJson from "../../../assets/config/customer.json";
import { ArchiveModalComponent } from '../../shared/views/ArchiveModalComponent/archive.modal.component';

import { EmployerType } from '../../shared/enum/EmployerType'
import { EntityTypes } from '../../shared/enum/EntityTypes';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { PersonViewService } from '../../PersonComponent/PersonViewComponent/person.view.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { HttpResponse, HttpEventType, HttpHeaderResponse } from '@angular/common/http';
import { ErrorModalComponent } from '../../shared/views/ErrorModalComponent/error.modal.component';
import { Countries } from '../../shared/countries/countries';
import { AuthenticationService } from '../../auth';

@Component({
    selector: 'employer-comp',
    providers: [EmployerViewService, ConfirmService, NgxSmartModalService, AppService, PersonViewService, Countries, AuthenticationService],
    templateUrl: './employer.view.component.html',
    styleUrls: ['../employer.component.css']
})

export class EmployerViewComponent {   

    @ViewChild('errorModalComponent') errorModalComponent: ErrorModalComponent;
    @ViewChild('archiveModal') archiveModal: ArchiveModalComponent;
    @ViewChild('pdfAttachmentViewer') pdfAttachmentViewer;

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private customerOrgId: String = customerJson.customer.organisationId;

    otherType: String = 'suaProject';
    selectedEmployer: any;

    isCustomer: boolean = false;

    private employerRks: any = [];    

    showContacts: Boolean = false;

    confDepartmentName: String = AppConfig.settings.avdelningstitel;

    /* View employer */
    showEmployerInformation: Boolean = true;
    showOtherInformation: Boolean = true;
    showDateDetailsInformation: Boolean = true;
    showRegisterDetailsInformation: Boolean = true;
    showContactDetailsInformation: Boolean = true;
    showNoteEditor: Boolean = false;
    showNotesDetails: Boolean = true;
    showLoader: Boolean = false;
    public projects: any = [];

    id: String;
    ready: Boolean = false;

    employerType = EmployerType;
    entityType = EntityTypes;
    subEmployerList: any = [];
    parentEmployer: any;

    /** attachment */
    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;
    public uploader: FileUploader = new FileUploader({allowedFileType: ["pdf"]});
    private attachmentContent: any;
    private showContentForAttachment: Boolean = false;
    private newAttachment: Boolean = false;
    showAttBody: Boolean = false;
    numOfNotes:number = 0;
    private translatedOrgType: string = "";
    
    pdfBlob: any = null;
    pdfName: string = null;
    currentPdfView: string = '';

    /**
     * Constructor
     * @param service           Service for this view
     * @param confirmService    Service for confirm modal
     * @param activatedRoute    Route for the URL
     * @param location          To be able to go back to previous view
     * @param appService        General service for whole app
     */
    constructor(
        private service: EmployerViewService,
        private confirmService: ConfirmService,
        private activatedRoute : ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private ngxSmartModalService: NgxSmartModalService,
        private personViewService: PersonViewService,
        private sanitizer: DomSanitizer,
        private globals: Globals,
        private countries: Countries,
        private authService: AuthenticationService
    ) {
        this.authService.isAuthenticated();
        this.id = this.activatedRoute.snapshot.paramMap.get('id');
        this.setDefault();
    }

    setDefault() {
        this.viewEmployer(this.id);
        this.getAllSuaProjectByEmployerId(this.id);        
    }

    /**
     * Go back to the previous view from where we came
     */
    back() {
        this.appService.setRoute("/employer");
    }

    /**
     * Set the URL-route to the specified route
     * @param route Route to change to
     */
    setRoute(route) {
        this.appService.setRoute(route);
    }

    /* Show or hide employer details */
    showEmployerDetails() {
        this.showEmployerInformation = !this.showEmployerInformation;
    }

    /* Show or hide other details */
    showOtherDetails() {
        this.showOtherInformation = !this.showOtherInformation;
    }

    /** Sets type to show in table */
    setOtherType(type) {
        this.otherType = type;
        if(type === 'subEmployer'){
            this.getSubEmployers();
        }
    }

    /* Show or hide date details */
    showDateDetails() {
        this.showDateDetailsInformation = !this.showDateDetailsInformation;
    }

    /* Show or hide register details */
    showRegisterDetails() {
        this.showRegisterDetailsInformation = !this.showRegisterDetailsInformation;
    }

    /* Show or hide contact details */
    showContactDetails() {
        this.showContactDetailsInformation = !this.showContactDetailsInformation;
    }

    validateInput(inputName, formArray) {
        let validInput = true;
        for(let i=0; i < formArray.length; i++) {
            if (inputName.toUpperCase() == formArray.value[i].departmentName.toUpperCase()) {
                validInput = false;
            }
        }
        return validInput;
    }
    
    /* Error modal on employer creation */
    showError(error) {
        if(error.message == undefined){
            this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
        } else {
            this.confirmService.error(error.message);
        }
    }

    getAllSuaProjectByEmployerId(supplierId) {
        this.service.getAllSuaProjectByEmployerId(supplierId).subscribe(
            data => {this.setSuaData(data)},
            error => this.showError(error.error)
        )
    }

    /**
     * Get all register controls related to the specific organisation
     * @param supplierId   
     */ 
    getAllEmployerRks(supplierId: String): Promise<void> { 
        return new Promise<void>(resolve => {
            this.service.getAllSuaRegisterControls(supplierId).subscribe(
                data => {
                    this.employerRks = data;      
                    resolve();                  
                },
                error => this.showError(error.error)                
            )  
        });  
    }    

    /* Updates the status for a employer */
    archiveSupplier(supplierId) {

        // Setup entity
        let entityObject = this.archiveModal.createEntityObject(this.entityType.SUPPLIER, supplierId,[]);

        // Setup object (SUA in this case)
        let suaObject = this.archiveModal.setupDefaultSuaData();
        
        // Setup data objects specific for entity, in this case for SUA
        for(let i=0; i < this.selectedEmployer.projectList.length; i++) {
          let project = this.selectedEmployer.projectList[i];
          let placeholder;
          // Conversion required as we dont have a readable name for the type
          if(!project.archived) {
              if(project.compSecContractLevel === 'levelThree') {
                  placeholder = this.i18.sua.form.suaLevel3Label;
              } else if(project.compSecContractLevel === 'levelTwo') {
                  placeholder = this.i18.sua.form.suaLevel2Label;
              } else if(project.compSecContractLevel === 'levelOne') {
                  placeholder = this.i18.sua.form.suaLevel1Label;
              } else {
                  placeholder = this.i18.sua.form.noSuaLevel;
              }
              // Push each projects information as data object
              suaObject.objectArray.push(this.archiveModal.createModalObject(placeholder,project.compIndustry,project.compProjectName));
          }
        }
        // Push our SUA object to the entity as we are done constructing it
        // Make sure we got SUA's that are supposed to be archived before we push it
        if(suaObject.objectArray.length > 0) {
            entityObject.dataArray.push(suaObject);
        }

        // Setup another object (RK in this case)
        let rkObject = this.archiveModal.setupDefaultRkData();

        this.getAllEmployerRks(supplierId).then( () => {

            for(let n = 0; n < this.employerRks.length; n++) {
                let rk = this.employerRks[n];
                // Push each rk information as data object
                if(!rk.archived) {
                  rkObject.objectArray.push(this.archiveModal.createModalObject(rk.rkRegNumber,rk.status,rk.purposeOfControl));
                }
            }
            // Push our RK object to the entity as we are done constructing it
            if(rkObject.objectArray.length > 0) {
                entityObject.dataArray.push(rkObject);
            }
    
    
            // Finalize entity and prepare to show modal
            this.archiveModal.setEntityData(entityObject);
    
            // Display modal
            this.archiveModal.pop();
        });        
    }

    unarchiveEmployer(supplierId) {
        this.confirmService.confirm(this.i18.organisation.form.unarchiveEmployer)
          .then(result => {
            if (result) {
                this.service.updateEmployerStatus(supplierId)
                  .subscribe(
                    data => this.displayEmployer(data),
                    error => this.showError(error)
                  );
              }
          });
    }

    /**
     * Sets the selected employer to be the data in the data parameter
     * @param data json data of the employer to be set
     */
    displayEmployer(data) {   
        this.selectedEmployer = data;
        this.selectedEmployer.showNotesDetails = true;
        this.selectedEmployer.showNoteEditor = false;
        
        this.selectedEmployer.contacts.forEach(contact => {
            if((contact.contactName != null && contact.contactName.length > 0) ||
              (contact.contactPhone != null && contact.contactPhone.length > 0) ||
              (contact.contactMail != null && contact.contactMail.length > 0)){
              this.showContacts = true;
            }
        });
       
        this.translatedOrgType = this.appService.getTranslatedOrgType(this.selectedEmployer.employerType);

        if (this.selectedEmployer.organisationId === this.customerOrgId) {
            this.isCustomer = true;
        }
        // set the number of notes on first load. this will then be updated when a user adds/removes notes
        this.numOfNotes = this.selectedEmployer.notes.length;

        if(this.selectedEmployer.parentOrganisationId !== null) {
            this.service.getEmployerById(this.selectedEmployer.parentOrganisationId)
                .subscribe(
                    data => this.setParentEmployer(data),
                    error => this.showError(error)
                );
        }

        this.ready = true;
    }

    /**
     * Sets all SUA's that belongs to the employer
     * @param data json data for all SUAs
     */
    setSuaData(data) {
        this.projects.length = 0;        
        for (let i = 0; i < data.length; i++) {            
            if (data[i].suaProjectStatus != 'Avslutad') {
                this.projects.push(data[i]);
            } 
        }
    }

    /**
     * Retrieve information about the employer to be viewed
     * @param id employers unique id
     */
    viewEmployer(id) {
        this.service.getEmployerById(id)      
          .subscribe(
            data => this.displayEmployer(data),
            error =>  this.showError(error.error)      
          );
    }

    showAttachment() {
        this.ngxSmartModalService.getModal('attachmentModal').open();
    }

    resetModal() {
        this.newAttachment = false;
        this.showAttBody = false;
        this.uploader.clearQueue();
    }

    showAttachmentBody() {
        this.showAttBody = true;
    }

    showUploader() {
        this.newAttachment = true;
    }

    getFiles(): FileLikeObject[] {
        return this.uploader.queue.map((fileItem) => {
            return fileItem.file;
        });
    }

    upload() {
        let files = this.getFiles();

        for(let i=0; i < files.length; i++) {
            let formData = new FormData();
            formData.append('file', files[i].rawFile, files[i].name);
            this.personViewService.upload(formData).subscribe(event => {
                if(event.status != 200) {
                    return;
                }
                if(event instanceof HttpResponse) {
                    let supplierAttachment = {
                        readableName: files[i].name,
                        uploadedDate: null,
                        attachmentType: "supplierAttachment"
                      }
                      this.personViewService.saveAttachment(supplierAttachment, "supplier", this.selectedEmployer.id).subscribe(
                          data => this.uploadReady(),
                          error => console.log(error)
                      )
                }
            })
        }
    }

    /**
     * Set's a pdf blob to be previewed upon user request
     * @param data pdf to view as blob
     * @param filename readable name of pdf file
     * @param elementId id of html elemet that triggered the preview
     */
    renderAttachment(data, filename, elementId) {
        this.currentPdfView = elementId;
        this.pdfName = filename;
        this.pdfBlob = new File([(data)], filename, {type: 'application/pdf'});
        if(this.pdfAttachmentViewer != undefined && this.pdfAttachmentViewer != null) {
        this.pdfAttachmentViewer.pdfSrc = this.pdfBlob;
        this.pdfAttachmentViewer.refresh();
        }
        this.showContentForAttachment = true;
    }

    /**
     * Closes the latest pdf preview 
     */
    clearPreview() {
        this.currentPdfView = '';
        this.pdfBlob=null;
        this.pdfName=null;
        this.attachmentContent = null;
        this.showContentForAttachment = false;    
    }

    sanitizeUrl(url) {
        this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.showContentForAttachment = true;
    }

    showAttachedFile(id, filename, elementId) {
        this.personViewService.showAttachedFile(id).subscribe(
            data => this.renderAttachment(data, filename, elementId),
            error => console.log(error)
        );
    }

    getEmployerById(id) {
        this.service.getEmployerById(id)      
          .subscribe(
            data => this.displayEmployer(data),
            error =>  this.showError(error.error)      
          );
    }

    uploadReady() {
        
        this.getEmployerById(this.id);
        this.uploader.clearQueue();
        this.newAttachment = false;
    }

    deleteAttachment(attachmentId, attachmentName){
        this.confirmService.confirm(this.i18.organisation.form.deleteAttachment + ' ' + attachmentName)
            .then(result => {
                if(result) {
                    this.service.deleteAttachment(attachmentId, this.id)
                        .subscribe(
                            data => this.getEmployerById(this.id),
                            error => this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error)
                        )
                }
            });
    }

    /**
     * Show error modal
     * @param modalData modalData array
     * @param error error msg
     */
     showErrorModal(modalData, error) {
        modalData[0] = error.header;
        modalData[1] = error.title;
        modalData[2] = error.message;
        this.errorModalComponent.pop();
    }

    /**
     * Anchor
     * @param target id
     */
     public anchor(target): void {
        this.appService.scrollToTarget(target);
    }

    /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
     setNumOfNotes(numOfNotes: number){
        if(numOfNotes != null && !Number.isNaN(numOfNotes)){
            this.numOfNotes = numOfNotes;
        } else {
            this.numOfNotes = this.selectedEmployer.notes.length;
        }
    }

    /**
     * get a list of all sub employers if they exist
     */
    getSubEmployers(){
        this.service.getAllsubEmployersByParentId(this.selectedEmployer.id)
            .subscribe(
                data => this.setSubEmployerList(data),
                error =>  this.showError(error.error)
          );
    }

    /**
     * Set the list of sub employers to be viewed in the table
     * @param data list of sub employers
     */
    setSubEmployerList(data){
        this.subEmployerList = data
    }

    /**
     * Set the parent for the employer currently beeing viewd
     * @param data parent employer object
     */
    setParentEmployer(data){
        this.parentEmployer = data;
    }

    /**
     * Change between paren and sub employers
     * @param employerId
     */
    changeEmployer(employerId){
        this.setRoute('employer/view/' + employerId);
        this.id = employerId;
        this.setOtherType('suaProject')
        this.setDefault();
    }
}